import { useRef } from 'react';

interface Props {
  errors: string[];
  onClose?: Function;
}
const ErrorInformation: React.FC<Props> = ({ errors, onClose }) => {
  const errorRef = useRef<HTMLElement>(null);

  const handleClose = () => {
    if (onClose) {
      onClose();
      return;
    }

    if (errorRef.current) {
      errorRef.current.setAttribute('data-ytope-message', 'inactive');
    }
  };

  return (
    <section className="ytope-message ytope-message--error" data-ytope-message="active" ref={errorRef}>
      <div className="ytope-message__close" data-ytope-close="" onClick={handleClose}></div>
      <div className="ytope-message__content" data-ytope-message-content="">
        {errors.map((error) => (
          <p className="mb-2">{error}</p>
        ))}
      </div>
    </section>
  );
};

export default ErrorInformation;
